import React from 'react';

const LanguageContext = React.createContext({
  language: "pt-br",
  setLanguage: () => {}
});

export default LanguageContext;